import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'

type IProps = {
  /** Sans callback, pas de bouton : ajouter et importer sont réservés à l'admin. */
  onAdd?: () => void
  onImport?: () => void
  onExport: () => void
}

/** Les actions de la barre de la liste des comptes. */
function UsersToolbarActions({ onAdd, onImport, onExport }: IProps) {
  const { t } = useTranslation()

  return (
    <>
      {onAdd && (
        <Button onClick={onAdd} {...tourAnchor('users.add')}>
          {t('common.add')}
        </Button>
      )}
      {onImport && (
        <Button variant="outline" onClick={onImport}>
          {t('common.import')}
        </Button>
      )}
      {/* L'export reste ouvert au formateur : c'est une lecture, sur la même
          population bornée que le tableau. */}
      <Button variant="outline" onClick={onExport} {...tourAnchor('users.export')}>
        {t('common.export')}
      </Button>
    </>
  )
}

export default UsersToolbarActions
